function CurrentWeekNum(year) {
    let d = new Date();


    if (year === '2022') {
        if(d >= new Date(2022, 8, 13) && d < new Date(2022, 8, 20)){
            return 2;
        } else if(d >= new Date(2022, 8, 20) && d < new Date(2022, 8, 27)){
            return 3;
        } else if(d >= new Date(2022, 8, 27) && d < new Date(2022, 9, 4)){
            return 4;
        } else if(d >= new Date(2022, 9, 4) && d < new Date(2022, 9, 11)){
            return 5;
        } else if(d >= new Date(2022, 9, 11) && d < new Date(2022, 9, 18)){
            return 6;
        } else if(d >= new Date(2022, 9, 18) && d < new Date(2022, 9, 25)){
            return 7;
        } else if(d >= new Date(2022, 9, 25) && d < new Date(2022, 10, 1)){
            return 8;
        } else if(d >= new Date(2022, 10, 1) && d < new Date(2022, 10, 8)){
            return 9;
        } else if(d >= new Date(2022, 10, 8) && d < new Date(2022, 10, 15)){
            return 10;
        } else if(d >= new Date(2022, 10, 15) && d < new Date(2022, 10, 22)){
            return 11;
        } else if(d >= new Date(2022, 10, 22) && d < new Date(2022, 10, 29)){
            return 12;
        } else if(d >= new Date(2022, 10, 29) && d < new Date(2022, 11, 6)){
            return 13;
        } else if(d >= new Date(2022, 11, 6) && d < new Date(2022, 11, 13)){
            return 14;
        } else if(d >= new Date(2022, 11, 13) && d < new Date(2022, 11, 20)){
            return 15;
        } else if(d >= new Date(2022, 11, 20) && d < new Date(2022, 11, 27)){
            return 16;
        } else if(d >= new Date(2022, 11, 27) && d < new Date(2023, 0, 3)){
            return 17;
        } else if(d >= new Date(2023, 0, 3) && d < new Date(2023, 0, 10)){
            return 18;
        } else {
            return 1;
        }
    }
    
    if (year === '2023') {
        if(d >= new Date(2023, 8, 12) && d < new Date(2023, 8, 19)){
            return 2;
        } else if(d >= new Date(2023, 8, 19) && d < new Date(2023, 8, 26)){
            return 3;
        } else if(d >= new Date(2023, 8, 26) && d < new Date(2023, 9, 3)){
            return 4;
        } else if(d >= new Date(2023, 9, 3) && d < new Date(2023, 9, 10)){
            return 5;
        } else if(d >= new Date(2023, 9, 10) && d < new Date(2023, 9, 17)){
            return 6;
        } else if(d >= new Date(2023, 9, 17) && d < new Date(2023, 9, 24)){
            return 7;
        } else if(d >= new Date(2023, 9, 24) && d < new Date(2023, 9, 31)){
            return 8;
        } else if(d >= new Date(2023, 9, 31) && d < new Date(2023, 10, 7)){
            return 9;
        } else if(d >= new Date(2023, 10, 7) && d < new Date(2023, 10, 14)){
            return 10;
        } else if(d >= new Date(2023, 10, 14) && d < new Date(2023, 10, 21)){
            return 11;
        } else if(d >= new Date(2023, 10, 21) && d < new Date(2023, 10, 28)){
            return 12;
        } else if(d >= new Date(2023, 10, 28) && d < new Date(2023, 11, 5)){
            return 13;
        } else if(d >= new Date(2023, 11, 5) && d < new Date(2023, 11, 12)){
            return 14;
        } else if(d >= new Date(2023, 11, 12) && d < new Date(2023, 11, 19)){
            return 15;
        } else if(d >= new Date(2023, 11, 19) && d < new Date(2023, 11, 26)){
            return 16;
        } else if(d >= new Date(2023, 11, 26) && d < new Date(2024, 0, 2)){
            return 17;
        } else if(d >= new Date(2024, 0, 2) && d < new Date(2024, 0, 9)){
            return 18;
        } else {
            return 1;
        }
    }

    if (year === '2024') {
        if(d >= new Date(2024, 8, 10) && d < new Date(2024, 8, 17)){
            return 2;
        } else if(d >= new Date(2024, 8, 17) && d < new Date(2024, 8, 24)){
            return 3;
        } else if(d >= new Date(2024, 8, 24) && d < new Date(2024, 9, 1)){
            return 4;
        } else if(d >= new Date(2024, 9, 1) && d < new Date(2024, 9, 8)){
            return 5;
        } else if(d >= new Date(2024, 9, 8) && d < new Date(2024, 9, 15)){
            return 6;
        } else if(d >= new Date(2024, 9, 15) && d < new Date(2024, 9, 22)){
            return 7;
        } else if(d >= new Date(2024, 9, 22) && d < new Date(2024, 9, 29)){
            return 8;
        } else if(d >= new Date(2024, 9, 29) && d < new Date(2024, 10, 5)){
            return 9;
        } else if(d >= new Date(2024, 10, 5) && d < new Date(2024, 10, 12)){
            return 10;
        } else if(d >= new Date(2024, 10, 12) && d < new Date(2024, 10, 19)){
            return 11;
        } else if(d >= new Date(2024, 10, 19) && d < new Date(2024, 10, 26)){
            return 12;
        } else if(d >= new Date(2024, 10, 26) && d < new Date(2024, 11, 3)){
            return 13;
        } else if(d >= new Date(2024, 11, 3) && d < new Date(2024, 11, 10)){
            return 14;
        } else if(d >= new Date(2024, 11, 10) && d < new Date(2024, 11, 17)){
            return 15;
        } else if(d >= new Date(2024, 11, 17) && d < new Date(2024, 11, 24)){
            return 16;
        } else if(d >= new Date(2024, 11, 24) && d < new Date(2024, 11, 31)){
            return 17;
        } else if(d >= new Date(2024, 11, 31) && d < new Date(2025, 0, 7)){
            return 18;
        } else {
            return 1;
        }
    }

    // This is only ever a same-render synchronous placeholder -- the real
    // week comes from the server and overwrites it as soon as that response
    // arrives (see EnterPicks.js/CurrentWeek.js/Admin.js). For 2026+ there's
    // no year-specific ladder below (this whole block is 2025's actual
    // dates), and its upper bound on the last rung ('< new Date(2026, 11, 6)')
    // happens to span all of 2026 too, so every 2026 load was guessing week
    // 18 -- always wrong, which forces an extra round-trip once the server
    // corrects it. Guess 1 instead for any year this ladder doesn't actually
    // cover; still just a placeholder, but a far more often-right one at the
    // point in the season this matters most (kickoff).
    if (Number(year) >= 2026) {
        return 1;
    }

    if(d >= new Date(2025, 8, 9) && d < new Date(2025, 8, 16)){
        return 2;
    } else if(d >= new Date(2025, 8, 16) && d < new Date(2025, 8, 23)){
        return 3;
    } else if(d >= new Date(2025, 8, 23) && d < new Date(2025, 8, 30)){
        return 4;
    } else if(d >= new Date(2025, 8, 30) && d < new Date(2025, 9, 7)){
        return 5;
    } else if(d >= new Date(2025, 9, 7) && d < new Date(2025, 9, 14)){
        return 6;
    } else if(d >= new Date(2025, 9, 14) && d < new Date(2025, 9, 21)){
        return 7;
    } else if(d >= new Date(2025, 9, 21) && d < new Date(2025, 9, 28)){
        return 8;
    } else if(d >= new Date(2025, 9, 28) && d < new Date(2025, 10, 4)){
        return 9;
    } else if(d >= new Date(2025, 10, 4) && d < new Date(2025, 10, 11)){
        return 10;
    } else if(d >= new Date(2025, 10, 11) && d < new Date(2025, 10, 18)){
        return 11;
    } else if(d >= new Date(2025, 10, 18) && d < new Date(2025, 10, 25)){
        return 12;
    } else if(d >= new Date(2025, 10, 25) && d < new Date(2025, 11, 2)){
        return 13;
    } else if(d >= new Date(2025, 11, 2) && d < new Date(2025, 11, 9)){
        return 14;
    } else if(d >= new Date(2025, 11, 9) && d < new Date(2025, 11, 16)){
        return 15;
    } else if(d >= new Date(2025, 11, 16) && d < new Date(2025, 11, 23)){
        return 16;
    } else if(d >= new Date(2025, 11, 23) && d < new Date(2025, 11, 30)){
        return 17;
    } else if(d >= new Date(2025, 11, 30) && d < new Date(2026, 11, 6)){
        return 18;
    } else {
        return 1;
    }
    
}

export default CurrentWeekNum;